import { createRootRoute, Outlet } from '@tanstack/react-router'
import { Provider as JotaiProvider } from 'jotai'
import { ThemeProvider } from '../contexts/ThemeContext'
import { Layout } from '../components'
import '../styles/global.css'
import { ExternalLibs } from '../components/ExternalLibs/ExternalLibs'
import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundary'
import { NotFoundPage } from '@/components/infoPages/NotFoundPage'

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: ErrorBoundary,
  notFoundComponent: NotFoundPage,
})

function RootComponent() {
  return (
    <JotaiProvider>
      <ExternalLibs />
      <ThemeProvider>
        <Layout>
          <Outlet />
        </Layout>
      </ThemeProvider>
    </JotaiProvider>
  )
}